import {StyledEngineProvider, ThemeProvider} from '@mui/material';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {Helmet} from 'react-helmet';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';

import QueryDevtools from 'App/main/queryDevtools';

import history from '../../browser_history';
import NotificationContainer from '../../components/common/components/notification_container';
import RootRoutes from '../../components/routes';
import {buildrzTheme} from '../../themes/buildrz';
import store from '../store/store';

import ErrorBoundary from './errorBoundary';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={buildrzTheme}>
            <BrowserRouter history={history}>
              <Helmet title="Buildrz" />
              <ErrorBoundary>
                <RootRoutes />
              </ErrorBoundary>
              <NotificationContainer />
            </BrowserRouter>
          </ThemeProvider>
        </StyledEngineProvider>
      </Provider>
      <QueryDevtools />
    </QueryClientProvider>
  );
}

export default App;
